import React from 'react';
import { Box, Typography } from '@mui/material';
import type { SvgIconComponent } from '@mui/icons-material';

export type AppStageBadgeProps = {
  icon: SvgIconComponent;
  label: string;
};

/**
 * Compact context chip shown next to the Flock logo so users always know which
 * workflow stage they are in (mirrors the home “workflow” cards).
 */
export function AppStageBadge({ icon: Icon, label }: AppStageBadgeProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        ml: 2,
        pl: 2,
        borderLeft: '1px solid #3f3f46',
        height: 44,
        flexShrink: 0,
      }}
      aria-label={`Current area: ${label}`}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 36,
          height: 36,
          borderRadius: 1,
          bgcolor: '#27272a',
        }}
      >
        <Icon sx={{ fontSize: 22, color: '#e4e4e7' }} />
      </Box>
      <Typography
        component="span"
        sx={{
          color: '#a1a1aa',
          fontSize: '0.8125rem',
          fontWeight: 600,
          letterSpacing: '0.02em',
          display: { xs: 'none', sm: 'inline' },
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}
